<template>
  <div
    v-on-clickaway="cancel"
    class="field-box"
    :class="{ 'field-box--error' : hasError }"
  >
    <slot />
  </div>
</template>
<script>
import { inject, provide } from '@vue/composition-api'
import { mixin as clickaway } from 'vue-clickaway'

export default {
  mixins: [ clickaway ],
  props: {
    isEditing: {
      type: Boolean,
      default: false,
    },
    hasError: {
      type: Boolean,
      default: false,
    },
    index: {
      type: [ String, Number ],
      required: false,
    },
    isArray: {
      type: Boolean,
      default: true,
    },
  },
  setup (props) {
    if (![ undefined, null, '' ].includes(props.index)) {
      const dynamicFieldQuestionPath = inject('dynamic_field_question_path', [])
      const dynamicFieldValuePath = inject('dynamic_field_value_path', dynamicFieldQuestionPath)
      provide('dynamic_field_value_path', [ ...dynamicFieldValuePath, props.index ])
      if (!props.isArray) provide('dynamic_field_question_path', [ ...dynamicFieldQuestionPath, props.index ])
    }
  },
  methods: {
    cancel () {
      this.$emit('cancel')
    },
  },

}
</script>
<style scoped>
.field-box {
  border-left: 4px var(--gray) solid;
  background-color: rgba(0, 0, 0, 0.01);
}

.field-box--edit {
  border-color: var(--blue);
}
.field-box--error {
  border-color: var(--red);
}
</style>
